import template from './query-variables.html';
import controller from './query-variables.controller';
import './query-variables.scss';

export default {
	controller,
	template,
	bindings: {
		variables: '<ngModel',
	},
	require:  {
		editor:      '^^?queryEditor',
		ngModelCtrl: '?ngModel',
	},
};
